/* ============================================================
   BOOTWORLD — Collection Filter & Sort Engine
   Handles:
   - Dynamic sorting (Featured, Price Low->High, Price High->Low, Title A->Z)
   - 6 Collection pill navigation sync
   ============================================================ */

(function () {
  'use strict';

  let initialized = false;

  const CollectionSort = {
    grid: null,
    allCards: [],
    originalOrder: [],

    init() {
      if (initialized) return;
      const collectionGrid = document.querySelector('#collection-product-grid, [data-collection-grid]');
      if (!collectionGrid) return;

      initialized = true;
      this.grid = collectionGrid;
      this.allCards = [...this.grid.querySelectorAll('.product-card')];
      this.originalOrder = [...this.allCards];

      // Sort selector
      const sortEl = document.querySelector('[data-sort-select], #collection-sort-select');
      if (sortEl) {
        sortEl.addEventListener('change', e => this.onSort(e.target.value));
      }
    },

    onSort(value) {
      if (!this.grid || !this.allCards.length) return;

      if (value === 'featured') {
        this.originalOrder.forEach(card => {
          this.grid.appendChild(card);
        });
        return;
      }

      const visibleCards = [...this.allCards];

      visibleCards.sort((a, b) => {
        const pa = parseInt((a.dataset.price || '0').replace(/\D/g, ''), 10);
        const pb = parseInt((b.dataset.price || '0').replace(/\D/g, ''), 10);
        const ta = (a.querySelector('.product-card__title a, .product-card__title')?.textContent || '').trim().toLowerCase();
        const tb = (b.querySelector('.product-card__title a, .product-card__title')?.textContent || '').trim().toLowerCase();

        switch (value) {
          case 'price-asc':  return pa - pb;
          case 'price-desc': return pb - pa;
          case 'title-asc':  return ta.localeCompare(tb);
          default: return 0;
        }
      });

      visibleCards.forEach(card => this.grid.appendChild(card));
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => CollectionSort.init());
  } else {
    CollectionSort.init();
  }
})();
